import type { Tour } from '../../types'
import { validateTours } from '../../utils/validate-tours'
import { findPageTour } from '../../utils/eligibility'
import { appOverviewTour } from './app-overview'
import { workspaceTours } from './workspace'
import { dashboardTours } from './dashboards'
import { libraryTours } from './library'
import { adminTours } from './admin'
import { financeTours } from './finance'
import { registerNavPageTours } from './nav-items'

/**
 * The tour registry. Data only — adding a tour or step never touches the
 * engine. Page-tour order matters only where matchers overlap (none today;
 * the registry test asserts every route shape resolves to one tour).
 */
export const TOURS: readonly Tour[] = [
  appOverviewTour,
  ...workspaceTours,
  ...dashboardTours,
  ...libraryTours,
  ...adminTours,
  ...financeTours,
]

// Overview group copy describes an item only if its route's rule passes.
registerNavPageTours(TOURS)

if (import.meta.env.DEV) validateTours(TOURS)

export const OVERVIEW_TOUR_ID = appOverviewTour.id

export function getTour(id: string): Tour | undefined {
  return TOURS.find((t) => t.id === id)
}

export function pageTourFor(pathname: string): Tour | undefined {
  return findPageTour(pathname, TOURS)
}
